import { useEffect, useState } from "react";
import {
  categoriaMensagemService,
  CategoriaMensagem,
} from "../../../services/categoriaMensagemService";

export const useCategoriasMensagem = () => {
  const [categorias, setCategorias] = useState<CategoriaMensagem[]>([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const carregarCategorias = async () => {
    setLoading(true);
    setErro(null);
    try {
      const data = await categoriaMensagemService.listarCategoriasMensagemService();
      if (data) setCategorias(data);
    } catch (error) {
      console.error("Erro ao carregar categorias de mensagem:", error);
      setErro("Erro ao carregar categorias de mensagem");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarCategorias();
  }, []);

  return {
    categorias,
    loading,
    erro,
    recarregar: carregarCategorias,
  };
};
